export default class ScrollVisibility {
  constructor() {
    this.isSupported = this.checkSupport();
    this.observer = null;

    if (!this.isSupported) {
      $('html').removeClass('is-observer');
      return;
    }

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            this.observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -15% 0px' },
    );
  }

  checkSupport() {
    return (
      'IntersectionObserver' in window &&
      'IntersectionObserverEntry' in window &&
      'isIntersecting' in window.IntersectionObserverEntry.prototype
    );
  }

  observe() {
    if (!this.observer) {
      return;
    }

    $('.js-visibility').each((i, el) => {
      this.observer.observe(el);
    });
  }
}
